import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Tooltip,
  Typography,
  makeStyles,
  styled,
} from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
  jaJP,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { SortState } from "../../../common/const";
import { Auth } from "aws-amplify";
import UpdateButton from "../../atoms/Button/UpdateButton";

import { green } from "@mui/material/colors";
import {
  CustomContainer,
  StyledDataGrid,
  customDataGridLocaleTextAll,
  customDataGridLocaleTextLoading,
  customDataGridLocaleTextNoData,
} from "../../../styles/styles";
import { Margin } from "@mui/icons-material";

interface Building {
  autoBuildingId: number;
  buildingId: string;
  buildingManagementId: string;
  buildingName: string;
  buildingAddress: string;
  memo: string;
}

const BuildingListPage = () => {
  const navigate = useNavigate();

  const [data, setData] = useState<Building[] | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | undefined>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      const session = await Auth.currentSession();
      try {
        // call indexBuildings API
        const response = await fetch(
          process.env.REACT_APP_API_ENDPOINT + "/buildings",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: session.getIdToken().getJwtToken(),
            },
          },
        );
        const jsonData = await response.json();
        setData(jsonData.buildings);
        setIsLoading(false);
        console.log("jsonData:" + JSON.stringify(jsonData));
      } catch (error: any) {
        setError(error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDoorListButtonClick = (buildingId: number) => {
    navigate(`/buildings/${buildingId}/doors`, { state: buildingId });
    console.log(`ドア一覧 button clicked` + "　選択された物件" + buildingId);
  };

  if (isLoading) {
    <Box display="flex" justifyContent="center" alignItems="center">
      <CircularProgress /> {/* MUIの CircularProgress コンポーネント */}
    </Box>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const columns: GridColDef[] = [
    {
      field: "buildingId",
      headerName: "物件システムID",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "buildingManagementId",
      headerName: "取付先コード（物件管理ID）",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "buildingName",
      headerName: "取付先名（物件名称）",
      flex: 1.5,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "buildingAddress",
      headerName: "住所",
      flex: 2,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "memo",
      headerName: "メモ",
      flex: 1.5,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "action",
      headerName: "操作",
      sortable: false,
      flex: 2,
      renderCell: (params: { row: { autoBuildingId: any } }) => {
        const buildingId = params.row.autoBuildingId;
        return (
          <>
            <Button
              variant="text"
              onClick={() => handleDoorListButtonClick(buildingId)}
            >
              ドア一覧
            </Button>
          </>
        );
      },
    },
  ];

  const rows = data
    ? data.map((building) => ({ id: building.autoBuildingId, ...building }))
    : [];

  return (
    <CustomContainer maxWidth={false}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="flex-start"
        marginBottom={2}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          管理物件一覧
        </Typography>
        <Box display="flex" width="100%" justifyContent="flex-end">
          <UpdateButton />
        </Box>
      </Box>

      <div style={{ height: 700, width: "100%" }}>
        <StyledDataGrid
          rows={rows}
          columns={columns}
          disableRowSelectionOnClick
          localeText={
            isLoading
              ? customDataGridLocaleTextLoading
              : rows.length === 0
                ? customDataGridLocaleTextNoData
                : customDataGridLocaleTextAll
          }
        />
      </div>
    </CustomContainer>
  );
};

export default BuildingListPage;
